import { Content } from '~/interfaces/Content';
import { GlobalAction } from '~/interfaces/GlobalAction';
import { CONTENT_REQUESTED, CONTENT_LOADED, ContentLoaded } from './App.actions';

const appReducer = (state: Content, action: GlobalAction): Content => {
  switch (action.type) {
    case CONTENT_REQUESTED:
      return contentRequest(state);
    case CONTENT_LOADED:
      return contentLoaded(state, action);
    default:
      return state;
  }
};

const contentRequest = (state: Content): Content => ({
  ...state,
  isLoaded: false,
});

const contentLoaded = (state: Content, action: ContentLoaded): Content => ({
  needHelp: action.contents.needHelp,
  businessHours: action.contents.businessHours,
  isLoaded: true,
});

export default appReducer;
